import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './NavlinkComponent.scss';

export const NavLinkComponent = ({expand}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    
    const toggleDropdown = (e) => {
        e.preventDefault();
        setShowDropdown(!showDropdown);
    };
    
    const handleDropdownItemClick = () => {
        setShowDropdown(false);
        if (expand) expand();
    };
    
    return (
        <React.Fragment>
            <NavLink
                className="Header__navigation__link"
                to="/" 
                href="/"
                exact
                activeClassName="active"
            >
                <span onClick={expand}>
                    HOME
                </span>
            </NavLink>
            
            <NavLink 
                className="Header__navigation__link"
                to="/booking" 
                href="/booking"
                activeClassName="active"
            >
                <span onClick={expand}>
                    BOOKING
                </span>
            </NavLink>

            <NavLink 
                className="Header__navigation__link airport-link"
                to="/budapest-airport-transfer" 
                href="/budapest-airport-transfer"
                activeClassName="active"
            >
                <span onClick={expand}>
                    <span className="airport-text-long">AIRPORT TRANSFER</span>
                    <span className="airport-text-short">AIRPORT</span>
                </span>
            </NavLink>

            <NavLink 
                className="Header__navigation__link f1-nav-link"
                to="/f1-hungaroring-transfer" 
                href="/f1-hungaroring-transfer"
                activeClassName="active"
            >
                <span onClick={expand}>
                    <i className="fa fa-flag-checkered"></i> 
                    <span className="f1-text-long">F1 HUNGARORING</span>
                    <span className="f1-text-short">F1</span>
                </span>
            </NavLink>
            
            <NavLink
                className="Header__navigation__link"
                to="/experiences" 
                href="/experiences"
                activeClassName="active"
            >
                <span onClick={expand}>
                    EXPERIENCES
                </span>
            </NavLink>
            
            <a 
                className="Header__navigation__link"
                href="/blog"
                activeClassName="active"
            >
                <span onClick={expand}>
                    BLOG
                </span>
            </a>

            {/* Info dropdown (About & Help) */}
            <div className="nav-dropdown desktop-only">
                <a 
                    href="#" 
                    className="Header__navigation__link dropdown-toggle"
                    onClick={toggleDropdown}
                >
                    <span>
                        INFO <i className="fa fa-chevron-down"></i>
                    </span>
                </a>
                
                <div className={`dropdown-menu ${showDropdown ? 'show' : ''}`}>
                    <NavLink 
                        className="dropdown-item"
                        to="/about" 
                        href="/about"
                        activeClassName="active"
                        onClick={handleDropdownItemClick}
                    >
                        <span>ABOUT US</span>
                    </NavLink>
                    
                    <NavLink
                        className="dropdown-item"
                        to="/help-center" 
                        href="/help-center"
                        activeClassName="active"
                        onClick={handleDropdownItemClick}
                    >
                        <span>HELP CENTER</span>
                    </NavLink>
                </div>
            </div>
            
            {/* Mobile links for About & Help */}
            <div className="mobile-only">
                <NavLink 
                    className="Header__navigation__link"
                    to="/about" 
                    href="/about"
                    activeClassName="active"
                >
                    <span onClick={expand}>
                        ABOUT
                    </span>
                </NavLink>
                
                <NavLink
                    className="Header__navigation__link"
                    to="/help-center" 
                    href="/help-center"
                    activeClassName="active"
                >
                    <span onClick={expand}>
                        <i className="fa fa-circle-question"></i> HELP
                    </span>
                </NavLink>
            </div>
        </React.Fragment>
    );
};
